import React, { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { images } from '../data/site';
const EASE = [0.23, 1, 0.32, 1] as const;
const shots = [{
  src: images.counter,
  alt: 'Croissants op marmeren toonbank',
  caption: 'Elke ochtend vers'
}, {
  src: images.cheesecake,
  alt: 'Cheesecake met rood fruit',
  caption: 'Seizoensgebonden'
}, {
  src: images.icedLatte,
  alt: 'Iced latte in geribbeld glas',
  caption: 'Huisblend koffie'
}];
export function Gallery() {
  const ref = useRef<HTMLElement | null>(null);
  const reduce = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const yA = useTransform(scrollYProgress, [0, 1], reduce ? ['0%', '0%'] : ['6%', '-6%']);
  const yB = useTransform(scrollYProgress, [0, 1], reduce ? ['0%', '0%'] : ['-4%', '10%']);
  return <section ref={ref} className="bg-cream px-6 py-20 lg:py-24" data-id="element-28" data-mp="21xzgk41morwm">
      <div className="mx-auto max-w-6xl" data-id="element-29" data-mp="21xpq6fco8iqe">
        <div className="max-w-3xl" data-id="element-30" data-mp="rct14xkn2tkw">
          <p className="text-sm text-clay" data-id="element-31" data-mp="rbrt71yx6n7e">Het huis</p>
          <h2 className="mt-4 text-[clamp(1.75rem,3.4vw,2.75rem)] font-medium leading-[1.2] tracking-[-0.02em] text-ink" data-id="element-32" data-mp="wbe5n96xbzf5">
            Een Franse patisserie in Nieuw-West, waar boterzachte laagjes, ambachtelijke koffie en
            een warm onthaal samenkomen.
          </h2>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-3" data-id="element-33" data-mp="8doxy5fs3u15">
          {shots.map((shot, i) => <motion.figure key={shot.src} style={{
          y: i === 1 ? yB : yA
        }} className={i === 1 ? 'sm:mt-12' : ''} data-id="element-34" data-mp="dcs2zpvre094" data-mpi={i}>
              <motion.div initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-10%'
          }} transition={{
            duration: 0.28,
            ease: EASE,
            delay: i * 0.05
          }} className="aspect-[3/4] overflow-hidden rounded-3xl bg-sand" data-id="element-35" data-mp="hd27ey3wkilv">
                <img src={shot.src} alt={shot.alt} className="h-full w-full object-cover" data-id="element-36" data-mp="3tv8h8e97edaw" />
              </motion.div>
              <figcaption className="mt-4 text-sm text-mist" data-id="element-37" data-mp="3pt4wez0n9wcy">{shot.caption}</figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}